<template>
  <section>
    <div class="protocolBox" v-if="!isUpdate">
      <h1 class="bold title">
        在您注册成为开放平台开发者的过程中，您需要完成我们的注册流程并通过点击同意的形式在线签署以下协议，请您务必仔细阅读、充分理解协议中的条款内容后点击同意：
      </h1>
      <p></p>
      <p>
        <a
          href="javascript:void(0);"
          class="primary-color bold"
          @click="_toPrivateProtocol"
          >《用户隐私权政策》</a
        >
      </p>
      <p></p>
      <p>
        <a
          href="javascript:void(0);"
          class="primary-color bold"
          @click="_toSecurityProtocol"
          >《开放平台开发者协议》</a
        >
      </p>
      <h1 class="bold title">
        如果您不同意上述协议或其中任何条款约定，请您停止注册。您停止注册后将仅可以浏览我们的网站展示信息无法享受我们的技术服务。如您按照注册流程提示填写信息，阅读并点击同意上述协议且完成全部注册流程后，即表示您可已充分阅读、理解并接受协议的全部内容；并表明您也同意可以依据以上的隐私政策内容来处理您的个人信息。
      </h1>
      <h1 class="bold title">
        点击同意即表示您已阅读并同意
        <a
          href="javascript:void(0);"
          class="primary-color"
          @click="_toPrivateProtocol"
          >《用户隐私权政策》</a
        >
        与
        <a
          href="javascript:void(0);"
          class="primary-color"
          @click="_toSecurityProtocol"
          >《开放平台开发者协议》</a
        >。
      </h1>
    </div>
    <div class="protocolBox" v-if="isUpdate">
      <h1 class="bold title">
        近期教育开放平台相关协议发生变更，您需要重新阅读并通过点击同意的形式重新签署以下协议，请您务必仔细阅读、充分理解协议中的条款内容后点击同意：
      </h1>
      <p></p>
      <p>
        <a
          href="javascript:void(0);"
          class="primary-color bold"
          @click="_toPrivateProtocol"
          >《用户隐私权政策》</a
        >
      </p>
      <p></p>
      <p>
        <a
          href="javascript:void(0);"
          class="primary-color bold"
          @click="_toSecurityProtocol"
          >《开放平台开发者协议》</a
        >
      </p>
      <h1 class="bold title">
        如果您不同意上述协议或其中任何条款约定，请您停止登录，您停止登录后将仅可以浏览我们的网站展示信息无法享受我们的技术服务。如您阅读并点击同意上述协议，即表示您可已充分阅读、理解并接受协议的全部内容，并表明您也同意可以依据以上的隐私政策内容来处理您的个人信息。
      </h1>
      <h1 class="bold title">
        点击同意即表示您已阅读并同意
        <a
          href="javascript:void(0);"
          class="primary-color"
          @click="_toPrivateProtocol"
          >《用户隐私权政策》</a
        >
        与
        <a
          href="javascript:void(0);"
          class="primary-color"
          @click="_toSecurityProtocol"
          >《开放平台开发者协议》</a
        >。
      </h1>
    </div>
    <div class="operation-btn">
      <el-button type="info" class="w150" @click="_refuseProtocol"
        >取消</el-button
      >
      <el-button type="warning" class="w150" @click="_aggreeProtocol"
        >同意</el-button
      >
    </div>
  </section>
</template>

<script>
export default {
  name: "security-protocol",
  data() {
    return {};
  },
  props: {
    isUpdate: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
  },
  computed: {},

  mounted() {},

  components: {},

  methods: {
    _aggreeProtocol() {
      this.$emit("aggree-protocol");
    },
    _refuseProtocol() {
      this.$emit("refuse-protocol");
    },
    _toSecurityProtocol() {
      const { route, href } = this.$router.resolve("/security-protocol-page");
      window.open(href, "_blank");
    },
    _toPrivateProtocol() {
      const { route, href } = this.$router.resolve("/private-protocol-page");
      window.open(href, "_blank");
    },
  },
};
</script>
<style scoped>
.protocolBox .title {
  font-size: 14px;
  padding: 15px;
}
.protocolBox .bold {
  font-weight: bold;
}

.protocolBox p {
  text-indent: 2em;
  line-height: 2;
  font-size: 14px;
}
.operation-btn {
  margin-top: 15px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/register/security-protocol.vue